import { AfterViewInit, Component, ElementRef, forwardRef, input, OnDestroy, Renderer2, ViewChild } from '@angular/core';
import { InputTextModule } from 'primeng/inputtext';
import { FloatLabel } from 'primeng/floatlabel';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';


@Component({
  selector: 'app-input-text',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputTextComponent),
      multi: true
    }

  ],
  imports: [InputTextModule, FloatLabel, FormsModule,],
  templateUrl: './input-text.component.html',
  styleUrl: './input-text.component.scss'
})
export class InputTextComponent implements ControlValueAccessor, AfterViewInit, OnDestroy {

  label = input.required<string>();
  htmlId = input.required<string>();
  type = input.required<string>();
  classInputText = input<string>('w-full md:w-[30rem]');


  value: string = '';
  onChange = (value: string) => { };
  onTouched = () => { };

  @ViewChild('customInputText') inputText: ElementRef | undefined;
  private _mutationObserver: MutationObserver = new MutationObserver(mutations => { //TODO Best solution with FormControl
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        if (this.inputText?.nativeElement) {
          const classList: DOMTokenList = this.elementRef.nativeElement.classList;

          if (classList.contains('ng-invalid')) {
            this.renderer.removeClass(this.inputText?.nativeElement, 'ng-valid');
          } else if (classList.contains('ng-valid')) {
            this.renderer.removeClass(this.inputText?.nativeElement, 'ng-invalid');
          }

          classList.forEach((v, _, __) => {
            this.renderer.addClass(this.inputText?.nativeElement, v);

          });
        }
      }
    })
  });

  constructor(private elementRef: ElementRef, private renderer: Renderer2) { }

  ngAfterViewInit() {
    this._mutationObserver.observe(this.elementRef.nativeElement, { attributes: true })
  }

  ngOnDestroy(): void {
    this._mutationObserver.disconnect();
  }

  writeValue(value: string): void {
    this.value = value;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

}
